<template>
    <el-dialog
        :title="title"
        :visible.sync="display"
        width="550px"
        :lock-scroll="false"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        @closed="closed">
        <div class="exam-info" v-if="exam">
            <div class="info-item">
                <label>考试名称：</label>
                <span>{{exam.ExamName}}</span>
            </div>
            <div class="info-item">
                <label>考试总分：</label>
                <span>{{exam.TotalScore}}</span>
            </div>
            <div class="info-item">
                <label>试题总量：</label>
                <span>{{exam.SubjectNum}}</span>
            </div>
            <div class="info-item">
                <label>考试时长：</label>
                <span>{{ exam.ExamTime === "0" ? "不限时长" : exam.ExamTime + "分钟" }}</span>
            </div>
            <div class="info-item" v-if="exam.ExamNum > 0">
                <label>限考次数：</label>
                <span>{{ exam.ExamNum }}</span>
            </div>
            <div class="info-item" v-if="exam.kscount > 0">
                <label>已考次数：</label>
                <span>{{ exam.kscount }}</span>
            </div>

            <div class="info-item">
                <label>考场须知：</label>
                <span>{{exam.Remark?exam.Remark:'---'}}</span>
            </div>
            <div class="info-item" v-if="exam.ExamPass">
                <label>考场密码：</label>
                <el-input class="item-text" v-model="password" placeholder="请联系管理员获取考场密码" show-password></el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="display = false">取 消</el-button>
            <el-button size="small" type="primary" @click="sure" v-loading="loading">
                {{isHomeWork ? "进入作业" : "进入考试"}}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { WriteCacheStartAnswer, GetRandomExamPaperId } from "@/api/exam";
import { nowString, uuid } from "@/utils";
import { ExamStatusHelper } from "@/mixins/examStatusHelper";

export default {
    name: "ExamInfo",
    mixins: [ExamStatusHelper],
    data() {
        return {
            display: false,
            password: "",
            exam: null,
            loading: false,
            requestExamPaperId: false,
        }
    },
    computed: {
        title() {
            if (this.exam) {
                return this.isHomeWork ? "作业信息" : "考试信息"
            } else {
                return ""
            }
        },
        isHomeWork() {
            if (this.exam) {
                return parseInt(this.exam.ExamType) === 2;
            } else {
                return false;
            }
        }
    },
    methods: {
        closed() {
            this.password = ""
        },
        /**
             * 显示弹窗
             * @param examInfo 考试信息
             * @param requestExamPaperId 重新请求试卷Id,以获取一张随机的试卷
             */
        show(examInfo, requestExamPaperId) {
            this.exam = examInfo;
            this.display = true;

            if (requestExamPaperId) {
                this.requestExamPaperId = true;
            }
        },
        async getRandomPagerIdAsync() {
            if (this.requestExamPaperId) {
                let { data } = await GetRandomExamPaperId({
                    examId: this.exam.ExamId
                });
                this.exam.ExamPaperId = data.data;
            }
        },
        sure() {
            if (this.exam.ExamPass) {
                if (this.password === "") {
                    this.$message.error("请输入密码")
                    return;
                }
                if (this.password !== this.exam.ExamPass) {
                    this.$message.error("密码错误")
                    return;
                }
            }
            // 限制及格后不能再考
            if (this.exam.PassAgain === "1") {
                let passScore = parseFloat(this.exam.PassScore) // 及格分数
                let maxScore = parseFloat(this.exam.ksScore)// 获得的最高分数
                if (maxScore >= passScore) {
                    this.$message("您已考试及格，无法再次参加本考试")
                    this.display = false
                    return;
                }
            }
            // 开始考试
            // 超过限定的时间进入考场则禁止考试
            let now = new Date().getTime();
            let date1 = new Date(this.exam.BeginTime.replace(/-/g, "/"));
            date1 = date1.getTime();
            if (
                this.exam.MaxLastTime !== "0" &&
                    parseInt(now) - parseInt(date1) > parseInt(this.exam.MaxLastTime) * 60 * 1000
            ) {
                this.$message(`超过${this.exam.MaxLastTime}分钟后禁止考试`)
                this.display = false
                return;
            }
            if (this.exam.ExamNum > 0 && parseInt(this.exam.kscount) >= parseInt(this.exam.ExamNum)) {
                this.$message(`您已达到最高考试次数限制${this.exam.ExamNum}次，禁止再次开始考试`)
                this.display = false
                return;
            }

            this.loading = true;

            this.getRandomPagerIdAsync().then(() => {
                WriteCacheStartAnswer({
                    exampaperId: this.exam.ExamPaperId,
                    examId: this.exam.ExamId
                }).finally(() => {
                    this.loading = false
                    this.display = false
                    let paperId = this.exam.ExamPaperId || this.exam.examPaperId;
                    const examUuid = this.genExamUuidAndStartExamStatus()
                    // go page
                    this.$router.push({
                        path: "/examDetail",
                        query: {
                            id: this.exam.ExamId,
                            paperId,
                            scorePublish: this.exam.ScorePublish,
                            isCheckScore: this.exam.IsCheckScore,
                            publishTime: this.exam.PublishTime,
                            ExamName: this.exam.ExamName,
                            ExamTime: this.exam.ExamTime,
                            MinExamTime: this.exam.MinExamTime,
                            startTime: nowString(),
                            examUuid
                        }
                    })
                })
            })
        }
    }
}
</script>

<style scoped lang="less">

    .exam-info {
      padding: 20px 0;

        .info-item {
            margin-top: 15px;
            font-size: 16px;
            color: black;
            text-align: left;
            padding-left: 80px;
            padding-right: 80px;
            display: flex;
            line-height: 1.5;

            label {
                width: 90px;
                flex-shrink: 0;
                text-align: right;
            }

            span {
                width: 470px;
                flex-grow: 1;
            }

            .item-text {
              width: 280px;
            }
        }

        .info-item:last-child {
            margin-bottom: 0;
        }

    }

     ::v-deep .el-dialog__body{
      border-top: 1px solid #dcdfe6;
      padding: 0;
      text-align: center;
      font-size: 12px;
    }

    ::v-deep .el-dialog__footer{
      height: 50px;
      border-top: 1px solid #dcdfe6;
      margin-top: 30px;
    }
</style>
